import Column from '@amzn/meridian/column';
import React from 'react';

import { CCXNegDataCheck } from '../helper';
import { DisplaySubMetricsProps } from '../types';
import CCXSubMetricComponent from './CCXSubMetricComponent';
import NoSubMetric from './Util/NoSubMetric';

const DisplayCCXNegativeSubMetrics: React.FC<DisplaySubMetricsProps> = ({
  metrics,
}: DisplaySubMetricsProps): React.ReactElement => {
  if (!metrics.CCX_NEG?.submetrics) {
    return <></>;
  }
  if (CCXNegDataCheck(metrics.CCX_NEG?.submetrics!)) {
    return <NoSubMetric />;
  }
  const {
    negativeEmpathy,
    negativeCourtesy,
    negativeKnowledgeable,
    negativeUnderstandability,
    negativeHelpfulness,
    negativeEfficiency,
  } = metrics.CCX_NEG?.submetrics!;

  return (
    <Column spacing='none' width='100%'>
      {negativeEmpathy && (
        <CCXSubMetricComponent
          metric={negativeEmpathy}
          titleStringId='cs_perfportal_lighthouse_empathy'
          titleDefaultMessage='Empathy'
          definitionStringId='cs_perfportal_lighthouse_negativeEmpathy_def'
          definitionDefaultMessage='Percentage of 1 to 2-star responses to the “Empathy” Customer Contact Experience (CCX) rating.'
        />
      )}
      {negativeCourtesy && (
        <CCXSubMetricComponent
          metric={negativeCourtesy}
          titleStringId='cs_perfportal_lighthouse_courtesy'
          titleDefaultMessage='Courtesy'
          definitionStringId='cs_perfportal_lighthouse_negativeCourtesy_def'
          definitionDefaultMessage='Percentage of 1 to 2-star responses to the “Courtesy” Customer Contact Experience (CCX) rating.'
        />
      )}
      {negativeKnowledgeable && (
        <CCXSubMetricComponent
          metric={negativeKnowledgeable}
          titleStringId='cs_perfportal_lighthouse_knowledgeable'
          titleDefaultMessage='Knowledgeable'
          definitionStringId='cs_perfportal_lighthouse_negativeKnowledgeable_def'
          definitionDefaultMessage='Percentage of 1 to 2-star responses to the “Knowledgeable” CCX rating.'
        />
      )}
      {negativeUnderstandability && (
        <CCXSubMetricComponent
          metric={negativeUnderstandability}
          titleStringId='cs_perfportal_lighthouse_understandability'
          titleDefaultMessage='Understandability'
          definitionStringId='cs_perfportal_lighthouse_negativeUnderstandability_def'
          definitionDefaultMessage='Percentage of 1 to 2-star responses to the “Easy to Understand” CCX rating.'
        />
      )}
      {negativeHelpfulness && (
        <CCXSubMetricComponent
          metric={negativeHelpfulness}
          titleStringId='cs_perfportal_lighthouse_helpfulness'
          titleDefaultMessage='Helpfulness'
          definitionStringId='cs_perfportal_lighthouse_negativeHelpfulness_def'
          definitionDefaultMessage='Percentage of 1 to 2-star responses to the “Helpfulness” Customer Contact Experience (CCX) rating.'
        />
      )}
      {negativeEfficiency && (
        <CCXSubMetricComponent
          metric={negativeEfficiency}
          titleStringId='cs_perfportal_lighthouse_efficiency'
          titleDefaultMessage='Efficiency'
          definitionStringId='cs_perfportal_lighthouse_negativeEfficiency_def'
          definitionDefaultMessage='Percentage of 1 to 2-star responses to the “Efficiency” Customer Contact Experience (CCX) rating.'
        />
      )}
    </Column>
  );
};

export default DisplayCCXNegativeSubMetrics;
